import { Component, createRef } from 'react'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import ImageResize from 'quill-image-resize-module-react'

import './quillStyles.css'
// Register the image resize module
Quill.register('modules/imageResize', ImageResize);

// Definieren der benutzerdefinierten Fonts
const Font = Quill.import('formats/font');
Font.whitelist = [
    'arial',
    'sans-serif',
    'montserat',
    'courier-new',
    'georgia',
    'times-new-roman',
    "helvetica",
    "lucida-sans",
    "roboto",
    "italianno",
    "happy-monkey"
  ];
Quill.register(Font, true);

// Benutzerspezifische Größen
//const Size = Quill.import('formats/size');
const Size = Quill.import('attributors/style/size');
Size.whitelist = ['12px', '8px', '10px', '16px', '18px', '20px', '24px', '48px', '60px', '72px']
Quill.register(Size, true);

class Editor extends Component {
  quillRef = createRef()

  undoChange = () =>{

    const myEditor = this.quillRef.current.getEditor()
    return myEditor.history.undo()
  }
  redoChange = () =>{
    const myEditor = this.quillRef.current.getEditor()
    return myEditor.history.redo()
}

imageHandler = () => {
  const input = document.createElement('input')
  input.setAttribute('type', 'file')
  input.setAttribute('accept', 'image/*')
  input.click()

  input.onchange = async () => {
    const file = input.files[0]
    if (file) {

      const imageData = await this.props.imageUpload(file)
      const { downloadURL } = imageData
      const quill = this.quillRef.current.getEditor()
      const range = quill.getSelection()
      // test URL const _downloadURL = 'https://firebasestorage.googleapis.com/v0/b/genfakt-4.appspot.com/o/test%2Fgoogle-bewertungen.png?alt=media&token=670e76b7-61bd-4971-933f-73713a6739c4'
      quill.insertEmbed(range.index, 'image', downloadURL)
    }
  }
}

  modules = {
    toolbar: {
        container: [
            [{ font: Font.whitelist}, { size: Size.whitelist }],
            [{ 'undo': 'undo' }, { 'redo': 'redo' }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] } ],
        
            [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
            { 'align': [] },
            ],
            ['link', 'image', 'video'],
            ['clean']
        ],
        handlers: {
            undo: () => this.undoChange(),
            redo: () => this.redoChange(),
            image: this.imageHandler
        },
    },
    history: {
        delay: 500,
        maxStack: 100,
        userOnly: true
    },
    clipboard: {
        matchVisual: false
    },
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }
};

  render() {

    return (
      <ReactQuill
        ref={this.quillRef}
        theme='snow'
        onChange={this.props.handleChangeCallback}
        value={this.props.editorState}
        modules={this.modules}
        formats={Editor.formats}
        bounds={'#root'}
        placeholder={this.props.placeholder}
      />
    );
  }
}//undo and redo in toolbar
const icons = Quill.import('ui/icons');
icons['undo'] = '<svg viewbox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>' +
  '<path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path></svg>';
icons['redo'] = '<svg viewbox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>' +
  '<path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path></svg>';

// Module mit Toolbar, die die neuen Fonts und Größen enthält


// Formate, die unterstützt werden sollen
Editor.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'color',
  'align',
  'background',
  'redo',
  'undo',
  'width',
  'height',
  'image'
];

export default Editor;
